import { render, staticRenderFns } from "./Deployments.vue?vue&type=template&id=5ac88f4a&scoped=true"
import script from "./Deployments.vue?vue&type=script&lang=js"
export * from "./Deployments.vue?vue&type=script&lang=js"
import style0 from "./Deployments.vue?vue&type=style&index=0&id=5ac88f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac88f4a",
  null
  
)

export default component.exports